import { render, staticRenderFns } from "./ProfileCardSkeleton.vue?vue&type=template&id=1fdec0fb&scoped=true&"
var script = {}
import style0 from "./ProfileCardSkeleton.vue?vue&type=style&index=0&id=1fdec0fb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fdec0fb",
  null
  
)

export default component.exports